import React from 'react'

function TenderTextLGZMLB() {
  return (
    <embed src="\pdfs\DAT2.5.2.1_LG-Z-M-LB_LG-ZUM-M-LB_Dezentrales_Lueftungsgeraet_fuer_Mischlueftung-liegend_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextLGZMLB